import TechnologyEnabled from '../../../assets/img/technology-enabled.png';

export default function BatchSection() {
  return (
    <>
      <section className="padding-tb-50px sm-ptb-30px bg-baby-pink baby-pink-wave" id="Batch">
        <div className="container">
          <div className="">
            <div className="row">
              <div
                className="col-md-6 wow fadeInLeft"
                data-wow-duration="1.5s"
                data-wow-offset="10"
              >
                <img width="100%" className="" src={TechnologyEnabled} alt="Distinction" />
              </div>
              <div
                className="col-md-6 wow fadeInRight"
                data-wow-duration="1.5s"
                data-wow-offset="10"
              >
                <div className="firo-title dark text-left margin-top-200px margin-left-30px margin-left-sm-0px sm-mb-20px sm-mt-30px">
                  <h2 className="title">Structured Curriculum</h2>
                  <div className="description line-height-30">
                    Regular interactions with students and parent about academic concerns of the
                    child.These session helps refuel the desire of student to succeed.
                  </div>
                  <a href="contact.php" className="firo-bottom sm mt-20">
                    View a Demo
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
